export default "__VITE_ASSET__BD8Cx17D__";